import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  private isMobileSubject = new BehaviorSubject<boolean>(false);
  private isSmallMobileSubject = new BehaviorSubject<boolean>(false);
  private isTabletSubject = new BehaviorSubject<boolean>(false);
  private isIpadLandscapeSubject = new BehaviorSubject<boolean>(false);
  private isIpadPortraitSubject = new BehaviorSubject<boolean>(false);

  isMobile$ = this.isMobileSubject.asObservable();
  isIpadPortrait$ = this.isIpadPortraitSubject.asObservable();

  constructor() {
    this.updateDeviceState();

    window.addEventListener('resize', () => {
      this.updateDeviceState();
    });
  }

  private updateDeviceState() {
    const portrait = window.matchMedia('(orientation: portrait)').matches;
    const landscape = window.matchMedia('(orientation: landscape)').matches;

    const width = window.innerWidth;
    const height = window.innerHeight;

    this.isMobileSubject.next(
      (width <= 480 && portrait) || (height <= 480 && landscape)
    );


    // iPad portrait sizes (width between 741 and 1366)
    const isTabletPortrait = (portrait: boolean, width: number): boolean => {
      // Typical tablet portrait widths range from 600 to 1035 logical pixels
      return portrait && width >= 600 && width <= 1035;
    };

    // Example usage:
    const currentWidth = window.screen.width;
    const isPortraitMode = window.screen.height > currentWidth;

    const isIpadInPortrait = isTabletPortrait(isPortraitMode, currentWidth);

    this.isIpadPortraitSubject.next(isIpadInPortrait);


  }




}
